const $ = jQuery.noConflict();

'use strict';
const Header = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */
	$domBody: $('body'),
	$domHeader: $('.site-header'),
	$domHeaderAccUser: $('.js-site-header__icon--account .site-header__icon-wrap'),
	$domHeaderAccDropdown: $('.js-site-header__icon--account-dropdown'),
	$domHeaderNotice: $('.js-site-header__notice'),
	$domHeaderNoticeIcon: $('.js-site-header__notice-desc-ico'),
	classHeaderScroll: 'is-sticky',
	classActive: 'is-active',
	classHasNotice: 'has-notice',
	classHasPadding: 'has-padding',

	/** @description Initialize */
	init: function() {
		this.headerScroll();
		this.headerStickyOnLoad();
		this.headerDropdownReveal();
		$(document).mouseup(function(e) {
			const container = $('.site-header__icon--account-dropdown');
			if (!container.is(e.target) && container.has(e.target).length === 0) {
				Header.$domHeaderAccDropdown.removeClass('is-visible');
			}
		});
		this.headerNoticeClose();
		this.headerBodyNotice();
	},

	headerScroll: function() {
		$(document).on('scroll', function() {
			const scrollTop = $(document).scrollTop();
			if(scrollTop > 20) {
				Header.$domHeader.addClass(Header.classHeaderScroll);
			} else {
				Header.$domHeader.removeClass(Header.classHeaderScroll);
			}
		});
	},

	headerStickyOnLoad: function() {
		$(window).on('load', function() {
			const scrollTop = $(document).scrollTop();
			if(scrollTop > 20) {
				Header.$domHeader.addClass(Header.classHeaderScroll);
			} else {
				Header.$domHeader.removeClass(Header.classHeaderScroll);
			}
		});
	},

	headerDropdownReveal: function() {
		if ($(window).width() < 1182) {
			Header.$domHeaderAccUser.on('click', function() {
				Header.$domHeaderAccDropdown.toggleClass('is-visible');
			});
		}
	},

	headerNoticeClose: function() {
		Header.$domHeaderNoticeIcon.on('click', function() {
			sessionStorage.setItem('headerNoticeClosed', 'true');

			Header.$domHeaderNotice.removeClass(Header.classActive);
			Header.$domHeader.removeClass(Header.classHasNotice);
			Header.$domBody.removeClass(Header.classHasPadding);
		});
	},

	headerBodyNotice: function() {
		if (sessionStorage.getItem('headerNoticeClosed') === 'true') {
			Header.$domHeaderNotice.removeClass(Header.classActive);
			Header.$domHeader.removeClass(Header.classHasNotice);
			Header.$domBody.removeClass(Header.classHasPadding);
			return;
		}

		if (Header.$domHeader.hasClass(Header.classHasNotice)) {
			Header.$domBody.addClass(Header.classHasPadding);
		} else {
			Header.$domBody.removeClass(Header.classHasPadding);
		}
	}
};

export default Header;